{
  "open": "فتح المحادثة",
  "unread_zero": "لا رسائل غير مقروءة",
  "unread_one": "رسالة واحدة غير مقروءة",
  "unread_two": "رسالتان غير مقروءتين",
  "unread_few": "{count} رسائل غير مقروءة",
  "unread_many": "{count} رسالة غير مقروءة",
  "unread_other": "{count} رسالة غير مقروءة",
  "close": "إغلاق"
}
